define('modules/lp_integration/models/emblue_data',['require','exports','module','backbone','env'],function(require,exports,module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    urlRoot: config.apiHost + "/emblue/data",
    initialize: function(attrs,options){
      this.fields = [];
      this.groups = new Backbone.Collection();
    },
    parse: function(json){
      this.fields = json.fields;
      this.groups.reset(json.groups);
      this.trigger("change:fields", this, this.fields);
      this.trigger("change:groups", this, this.groups);
      module.exports.__super__.parse.call(this, _.omit(json, ["fields", "groups"]));
    },
    toJSON: function(){
      return {
        fields: this.fields,
        groups: this.groups
      };
    }
  });
});

